module.exports = __webpack_public_path__ + "img/電気回路_2_4_4.89147c15.png";